<div [style.background-color]="generateColorFromString(itemBeingEdited.type.toLowerCase())">
  <form class="edit" (ngSubmit)="onSave()">
    <h2 mat-dialog-title>{{ itemBeingEdited.title || 'Untitled'}}</h2>
    <p mat-dialog-content>ID: {{itemBeingEdited.id}}</p>
    <mat-dialog-content>
      <div class="input-components">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <mat-icon matPrefix>title</mat-icon>
          <input matInput type="text" placeholder="E.g., My Big Project" name="title"
            [(ngModel)]="itemBeingEdited.title" />
          @if (itemBeingEdited.title) {
          <mat-icon matSuffix class="clear-input" (click)="itemBeingEdited.title=''">close</mat-icon>
          }
        </mat-form-field>

        <!-- Type-->
        <app-input-select [options]="typesOptions()" placeholder="E.g., Project" label="Type"
          (onOptionChange)="onTypeSelected($event, 'type')" [selectedOption]="itemBeingEdited.type"
          [isDisplayColorOption]="true" prefixIcon="task">
        </app-input-select>

        <!-- Status-->
        <app-input-select [options]="statusTypes()" placeholder="E.g., To Do" label="Status"
          (onOptionChange)="onTypeSelected($event, 'status')" [selectedOption]="itemBeingEdited.status"
          prefixIcon="circle">
        </app-input-select>
        <!-- Priority-->
        <app-input-select [options]="priorities()" placeholder="E.g., Critical" label="Priority"
          (onOptionChange)="onTypeSelected($event, 'priority')" [selectedOption]="itemBeingEdited.priority"
          prefixIcon="flag">
        </app-input-select>

        <mat-form-field>
          <mat-label>Size</mat-label>
          <mat-icon matPrefix>info</mat-icon>
          <input matInput type="number" class="size-input" min="0" placeholder="E.g. 0, 1, 1.3, 3.79, and 1000" name="size"
            [(ngModel)]="itemBeingEdited.size" (blur)="validateSizeInput($event)" #sizeInput="ngModel" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <mat-icon matPrefix>calendar_month</mat-icon>
          <input matInput [matDatepicker]="startDatePicker" name="startDate" [min]="today" placeholder="DD/MM/YYYY" (click)="startDatePicker.open()" [(ngModel)]="itemBeingEdited.start_date" (dateChange)="startDateChanged()">
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Due Date</mat-label>
          <mat-icon matPrefix>calendar_month</mat-icon>
          <input matInput [matDatepicker]="dueDatePicker" name="dueDate" [min]="itemBeingEdited.start_date || today" placeholder="DD/MM/YYYY" (click)="dueDatePicker.open()" [(ngModel)]="itemBeingEdited.due_date">
          <mat-datepicker #dueDatePicker></mat-datepicker>
        </mat-form-field>
      </div>  

      <div class="item-attribute-subscribed">
        <span>Subscribed to email updates?</span>
        <mat-checkbox [checked]="isSubscriber()" (change)="toggleWhetherSubscriber(isSubscriber())" />
      </div>

      <div class="item-attribute">
        <div class="attribute-label-wrapper">
          <span>Shared with</span>
          <span>Assignee?</span>
        </div>
        <div class="share-permissions">

          @for (permission of getInheritedPermissions(itemBeingEdited); track
          $index) {
          <div class="share-permission">
            <span class="{{isCurrentUser(permission.user.email) ? 'with-me' : 'not-with-me'}}">
              {{ permission.user.email }}
              <span [hidden]="!isCurrentUser(permission.user.email)">(Me)</span>
            </span>
            <mat-checkbox [checked]="isSubscriber()"
              (change)="addUserAsAssigneeWithExplicitPerm(permission.user.email)" />
          </div>
          }

          @for (permission of getExplicitPermissions(itemBeingEdited); track $index) {
          <div class="share-permission">
            <div class="{{isCurrentUser(permission.user.email) ? 'with-me' : 'not-with-me'}}">
              <mat-form-field>
                <input matInput type="text" name="email{{ $index }}" placeholder="Enter email"
                  [defaultValue]="permission.user.email" [(ngModel)]="permission.user.email"
                  maxlength="{{ accountService.otherAccountSettings().maxLengthShortText }}" [matAutocomplete]="auto"
                  [disabled]="isCurrentUser(permission.user.email) && itemBeingEdited.shared_with.length == 1">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  @for (email of getSuggestedEmails(itemBeingEdited); track $index) {
                  <mat-option [value]="email">{{email}}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              <span [hidden]="!isCurrentUser(permission.user.email)">(Me)</span>
            </div>

            <mat-checkbox class="assign-checkbox" [checked]="isAssigneeEdit(permission.user.email)" (change)="toggleWhetherAssignee(permission.user.email,
                  isAssigneeEdit(permission.user.email))" />
            <button mat-icon-button [disabled]="isCurrentUser(permission.user.email)" type="button"
              (click)="removeSharePermission(permission)" title="Remove permission" class="assign-button">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          }
        </div>
        <div class="{{this.addSharePermissionMessage() ? 'add-share-permission' : 'add-share-button' }}">
          <span>{{this.addSharePermissionMessage()}}</span>
          <button mat-icon-button type="button" (click)="addSharePermission($event)" title="Add share permission">
            <mat-icon fontIcon="person_add"></mat-icon>
          </button>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="item-attribute-tag">
        <div class="attribute-label-wrapper-tag">
          <span>Tags</span>
        </div>
        <app-tag-input [(tags)]="itemBeingEdited.tags" [allTags]="allSuggestedTags()" />
      </div>

      <mat-divider></mat-divider>

      <mat-form-field class="description">
        <mat-label>Description</mat-label>
        <textarea matInput placeholder="Ex. It makes me feel..." name="description"
          [(ngModel)]="itemBeingEdited.description" [rows]="5"></textarea>
      </mat-form-field>

      <div class="upload-files-wrapper">
        <div class="attach-file" (click)="openFileUploadDialog()" matTooltip="Attach files">
          <mat-icon>attach_file</mat-icon>
        </div>
        <app-thumbnail [attachments]="attachmentFiles" (removeFile)="removeFile($event)" />
      </div>

      <div class="item-attribute" [hidden]="itemBeingEdited.new">
        <span class="history-header">History:</span>
        <ul class="history-content">
          @for (record of itemBeingEdited.history; track $index) {
          <li class="history-record" [hidden]="hideHistory($index) && !isHistoryExpanded()">
            <div>
              <span>{{ generateHistoryRecordText(record).date }}</span>
              <span [innerHTML]="generateHistoryRecordText(record).text| highlightText: types"></span>
            </div>
          </li>
          }
          <a class="show-history-link" [hidden]="!additionalHistoryHidden()" (click)="showHideFullHistory()">{{
            isHistoryExpanded() ? 'Less' : 'More' }}</a>
        </ul>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="remove-item-wrapper" [hidden]="itemBeingEdited.new">
        <button mat-mini-fab (click)="onDelete()" type="button" [disabled]="fileUploadService.isFileUploading()"
          matTooltip="Delete Item">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <button mat-mini-fab (click)="onClose()" type="button" [disabled]="fileUploadService.isFileUploading()"
        matTooltip="Cancel">
        <mat-icon>cancel</mat-icon>
      </button>
      <button mat-mini-fab type="submit" [disabled]="fileUploadService.isFileUploading() || sizeInput.invalid" matTooltip="Save">
        @if (fileUploadService.isFileUploading()) {
        <mat-spinner diameter="20" color="primary"></mat-spinner>
        } @else {
        <mat-icon>check</mat-icon>
        }
      </button>
    </mat-dialog-actions>
  </form>
</div>